import React, { useEffect, useRef, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useDispatch } from 'react-redux'
import { createNewTemplateGql } from '@obeta/data/lib/actions/template-actions'
import { PopoverProps } from '../dropdown-button/PopoverDropdownMenu'
import { EntityDropdown, EntityDropdownSearchField } from '../entity-dropdown/EntityDropdown'
import { useBreakpoints } from '@obeta/data/lib/hooks/useBreakpoints'
import { SearchFacetElement } from '@obeta/models/lib/schema-models'
import { CART_TEMPLATE_NAME_MAX_LENGTH } from '@obeta/models/lib/models/CartTemplates/CartTemplate'

export interface IDropdownClassBaseProps {
  dropdown: Pick<PopoverProps, 'onClose' | 'open' | 'anchorEl' | 'transformOrigin' | 'anchorOrigin'>
  selectClass: (option: { id: string; name: string; count: number }) => void
  buttonId?: string
  classes: SearchFacetElement[]
}

export const DropdownClassesBase: React.FC<IDropdownClassBaseProps> = (props) => {
  const { selectClass, dropdown, buttonId, classes } = props
  const { mobile } = useBreakpoints()
  const [searchText, setSearchText] = useState('')
  const prevDropdownOpen = useRef(dropdown.open)
  const { t } = useTranslation()
  const dispatch = useDispatch()

  const [addEntityMode, setAddEntityMode] = useState<boolean>(false)

  const classesFilteredBySearch = classes.filter((classItem) => {
    const lowerName = classItem.meta.name.toLowerCase()
    const lowerSearchText = searchText.toLowerCase()
    return lowerName.includes(lowerSearchText)
  })

  useEffect(() => {
    if (prevDropdownOpen.current && !dropdown.open) {
      setSearchText('')
    }
    prevDropdownOpen.current = dropdown.open
  }, [dropdown.open])

  return (
    <EntityDropdown
      addEntityMode={addEntityMode}
      buttonId={buttonId}
      createEntityNameMaxLength={CART_TEMPLATE_NAME_MAX_LENGTH}
      createEntityPlaceholder={t('TEMPLATES.TEMPLATE_NAME')}
      createEntityTitle={t('TEMPLATES.CREATE')}
      topAdornment={<EntityDropdownSearchField mobile={mobile} onTextUpdated={setSearchText} />}
      mobile={mobile}
      onOptionSelected={(option) => {
        selectClass(option)
        dropdown.onClose()
      }}
      options={classesFilteredBySearch.map((classItem) => {
        return {
          id: classItem.value,
          name: classItem.meta.name,
          count: classItem.count,
        }
      })}
      onEntityCreated={(name) => {
        dispatch(createNewTemplateGql(name))
      }}
      setAddEntityMode={setAddEntityMode}
      {...dropdown}
      createEntityDisabled={true}
    />
  )
}
